import { PoolType, PoolTypeDisplay } from '../../types/pool';

interface PoolTypePillProps {
  poolType: PoolType | string;
}

const dotColorByType: Record<string, string> = {
  [PoolType.CHLORINE]: 'bg-electric',
  [PoolType.SALT]: 'bg-[#2bb1a0]',
};

const PoolTypePill = ({ poolType }: PoolTypePillProps) => {
  const label =
    PoolTypeDisplay[poolType as PoolType] ?? String(poolType ?? 'Unknown');
  const dotColor = dotColorByType[poolType] ?? 'bg-grey10';

  return (
    <span className="inline-flex items-center gap-1.5 text-sm text-dark font-medium">
      <span className={`w-[9px] h-[9px] rounded-full ${dotColor}`} />
      {label}
    </span>
  );
};

export default PoolTypePill;
